/**
 * Code which runs synchronously within a mutator cannot dispatch actions.
 * We do not normally expect this to be a problem, as mutators should merely mutate stores.
 * However, some mutators are doing things which are triggering some of the diagnostics middleware,
 * such as dispatching legacy satchel actions or making network calls.
 *
 * When the diagnostics middleware kicks in to track these operations, satchel will throw because
 * we dispatched a satchel 3 action in the synchronous call stack of a mutator.
 *
 * This function will attempt to dispatch an action and, if it fails due to being inside of a
 * mutator, will log a warning to the console and re-try inside of requestAnimationFrame which will
 * dispatch the action outside of the synchronous call context of the mutator.
 */
export const warnWhenDispatchedInMutator = (dispatchAction: () => void, warning: string) => {
    try {
        dispatchAction();
    } catch (ex) {
        // If the action failed because satchel stopped us from dispatching an action inside of a mutator
        if (
            (window as any).__satchelGlobalContext &&
            (window as any).__satchelGlobalContext.inMutator
        ) {
            // Warn and retry the dispatch outside of the synchronous call context of the mutator
            console.warn(warning, ex);

            // By dispatching in requestAnimationFrame, the corresponding diagnostics log could be out of order
            requestAnimationFrame(dispatchAction);
        } else {
            // For other types of exceptions, re-throw because it's unrelated to dispatching actions in mutators
            throw ex;
        }
    }
};
